import React, { useEffect, useState } from "react"
import { Alert, Button } from "antd"
import { useHistory, useLocation } from "react-router-dom"
import { useStoreState, StateMapper } from "easy-peasy"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faReceipt } from "@fortawesome/pro-regular-svg-icons"
import { AppDataStore } from "../../appData/types"
import { swimminglyApi } from "../utils"

interface ActivityFeedSummaryResponse {
  status?: string
  countsByCategory?: Record<string, number>
  summary?: {
    unreadByCategory?: Record<string, number>
  }
}

export default function WebsitesPaymentsNewAlert(): JSX.Element | null {
  const [loading, setLoading] = useState<boolean>(false)
  const [count, setCount] = useState<number>(0)
  const user = useStoreState((state: StateMapper<AppDataStore>) => state.user)
  const history = useHistory()
  const location = useLocation()

  useEffect(() => {
    let mounted = true

    const loadCount = async () => {
      setLoading(true)
      try {
        const query = user?.userId
          ? `?userId=${encodeURIComponent(String(user.userId))}`
          : ""
        const resp = await swimminglyApi.get(`/api/activity-feed/summary${query}`)
        const payload: ActivityFeedSummaryResponse =
          (resp as any)?.data && !Array.isArray(resp)
            ? (resp as any).data
            : (resp as any)

        const value =
          typeof payload?.countsByCategory?.billing === "number"
            ? payload.countsByCategory.billing
            : typeof payload?.summary?.unreadByCategory?.billing === "number"
              ? payload.summary.unreadByCategory.billing
              : 0
        if (mounted) {
          setCount(value)
        }
      } catch {
        if (mounted) {
          setCount(0)
        }
      } finally {
        if (mounted) {
          setLoading(false)
        }
      }
    }

    const handleViewed = () => {
      loadCount()
    }

    loadCount()
    window.addEventListener("swimmingly:activity-feed:refetch", handleViewed)
    window.addEventListener("websitesPaymentsViewed", handleViewed)

    return () => {
      mounted = false
      window.removeEventListener("swimmingly:activity-feed:refetch", handleViewed)
      window.removeEventListener("websitesPaymentsViewed", handleViewed)
    }
  }, [user?.userId])

  if (loading || count <= 0) {
    return null
  }

  // Only show on authenticated in-app routes
  if (!location.pathname.startsWith("/app")) {
    return null
  }

  const message =
    count === 1
      ? "You have a Websites payments receipt in your My Payments tab."
      : `You have ${count} Websites payments receipts in your My Payments tab.`

  return (
    <div style={{ padding: "0 12px", marginTop: 12, marginBottom: 12 }}>
      <Alert
        type="info"
        showIcon
        icon={<FontAwesomeIcon icon={faReceipt} />}
        title={message}
        action={
          <Button
            size="small"
            type="primary"
            onClick={() => {
              history.push("/app/billing?tab=websites")
            }}
          >
            View Receipt
          </Button>
        }
        closable={false}
      />
    </div>
  )
}
